import type { GuideTopic } from '../engine/types';

/**
 * How a topic reads inside a popover. Shared by the tour and the inline help
 * so the two never drift: topics.ts single-sources the copy, this
 * single-sources its presentation.
 */
export function GuideTopicBody({ topic }: { topic: GuideTopic }) {
  return (
    <>
      <p className="text-sm font-semibold text-gray-900">{topic.title}</p>
      <p className="mt-1 text-sm text-muted-foreground">{topic.body}</p>
      {topic.tip && (
        <p className="mt-2 rounded-md bg-blue-50 p-2 text-xs text-blue-800">
          {topic.tip}
        </p>
      )}
    </>
  );
}
